export default "__VITE_ASSET__B0Mk8GMB__"